import React from 'react';
import FixedBottomNavBar from '../../../../components/FixedBottomNavBar';
import Button from '../../../../components/Button';
import { reDirectPage, setDetailPageUrl } from '../../../../lib/common';
import {
  COUPON_COPY_URL_PATH,
  COUPON_EDIT_URL_PATH,
  COUPON_GENERATE_URL_PATH,
} from '../../../../constants/service/common/urlConstants';
import './CouponDetailNavbar.scss';

const CouponDetailNavbar = (props) => {
  const { couponId } = props;

  return (
    <FixedBottomNavBar className="coupon-detail-navbar">
      {/*복사하기*/}
      <Button
        color="light"
        text="복사"
        onClick={() => reDirectPage({ path: setDetailPageUrl(COUPON_COPY_URL_PATH, couponId) })}
      />

      {/*수정하기*/}
      <Button
        color="light"
        text="수정"
        onClick={() => reDirectPage({ path: setDetailPageUrl(COUPON_EDIT_URL_PATH, couponId) })}
      />

      {/*발급하기*/}
      <Button
        color="primary"
        text="발급하기"
        onClick={() => reDirectPage({ path: COUPON_GENERATE_URL_PATH, state: { couponId } })}
      />
    </FixedBottomNavBar>
  );
};

export default CouponDetailNavbar;
